import {createRouter, createWebHashHistory, createWebHistory} from "vue-router";
import UserContainer from "@/user/views/UserContainer.vue";
import UserAnalytics from "@/user/views/UserAnalytics.vue";
import SuperContainer from "@/user/views/SuperContainer.vue";
import SuperBusinessAdministration from "@/user/components/super/SuperBusinessAdministration.vue";
import SuperInvoices from "@/user/components/super/SuperInvoices.vue";
import SuperSupport from "@/user/components/super/SuperSupport.vue";
import SuperServers from "@/user/components/super/SuperServers.vue";
import BusinessesOverviewContainer from "@/user/views/BusinessesOverviewContainer.vue";
import BusinessesManagementContainer from "@/user/views/BusinessesManagementContainer.vue";
import SettingsContainer from "@/user/views/SettingsContainer.vue";

const routes = [
	{
		path: "/",
		component: UserContainer,
		children: [
			{
				path: "analytics",
				component: UserAnalytics
			},
			{
				path: "businesses",
				component: BusinessesManagementContainer
			},
			{
				path: "settings",
				component: SettingsContainer
			},
			{
				path: "super",
				component: SuperContainer,
				children: [
					{path: "", redirect: "/super/business"},
					{path: "business", component: SuperBusinessAdministration},
					{path: "invoices", component: SuperInvoices},
					{path: "chats", component: SuperSupport},
					{path: "servers", component: SuperServers}
				]
			},
			{
				path: "overview-businesses",
				component: BusinessesOverviewContainer
			},
		]
	},
];

const router = createRouter({
	history: import.meta.env.VITE_HISTORY_MODE === 'web' ? createWebHistory('/user/') : createWebHashHistory('/user/'),
	base: '/user/',
	routes,
});

export default router;